import { CheckCircle2, ChevronDown, MessageSquareText } from "lucide-react";
import SkillsTable from "./components/SkillsTable";
import { CircularMatchRating } from "../../components/CircularMatchRating";
import CurrentStatus from "../JobDetails/components/CurrentStatus";

const additionalRequirements = [
  "Strong understanding of responsive design and cross-browser compatibility.",
  "Experience with CI/CD pipelines and automated testing.",
  "Excellent problem-solving skills and attention to detail.",
];

const SkillsAndExperience = () => {
  return (
    <div className="flex flex-1 gap-3">
      {/* Column 1 */}
      <div className="flex flex-col flex-1 min-w-0 border rounded-md p-3 gap-3">
        {/* Header */}
        <div className="flex items-center justify-between gap-10">
          <div className="flex flex-col gap-1">
            <span className="font-bold text-sm">
              Required Skills & Experience
            </span>
            <span className="font-semibold text-xss text-blue-900">
              The key skills and experience required for this role. Review the
              details below to ensure you meet the requirements.
            </span>
          </div>
          <div className="flex items-center shrink-0 gap-3">
            <span className="font-semibold text-xss">Overall Match</span>
            <CircularMatchRating strokeWidth={2} percentage={78} size={50} />
          </div>
        </div>

        <SkillsTable />

        {/* Additional Experience */}
        <div className="flex flex-col gap-2 rounded-md bg-light-white-900 p-3 border">
          <div className="flex items-center justify-between">
            <span className="font-bold text-xs">
              Additional Experience Requirements (3)
            </span>
            <ChevronDown size={15} />
          </div>
          <div className="flex flex-col gap-2">
            {additionalRequirements?.map((requirement) => {
              return (
                <div className="flex items-center gap-2">
                  <CheckCircle2 size={12} color="green" />
                  <span className="text-xsss text-blue-700 font-semibold">
                    {requirement}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* Column 2 */}
      <div className="flex flex-col w-[30%] gap-3">
        {/* Current status section*/}
        <CurrentStatus />
        {/* Need help section */}
        <div className="flex items-center border bg-light-white-900 rounded-md p-3">
          <div className="flex flex-col gap-3">
            <span className="text-xss font-bold">Need help?</span>
            <span className="text-xsss font-semibold text-blue-900">
              If you have any question regarding your application, please
              contact the recruiter.
            </span>
            <button className="text-xss font-semibold rounded-md bg-white border w-max px-3 py-2">
              Contact Recruiter
            </button>
          </div>
          <div className="h-8 w-8 rounded-full flex items-center justify-center bg-gray-200 shrink-0">
            <MessageSquareText size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillsAndExperience;
